import React from 'react'
import i18next from 'i18next'
import {ActionButtons} from '@/pages/components'
import {LinkActionsMenu} from '@/pages/PayByLink/components'
import {PayByLinkStatus} from '@/constants'
import {PaymentLink, PaymentLinkOptionMode} from '@/api'
import {IPayByLinkStore} from '@/pages/PayByLink/IPayByLinkStore'

export const getPayByLinkListActionButtons = (
    link: PaymentLink,
    payByLinkStore: IPayByLinkStore
) => {
    const isMultiUse =
        link?.linkOptions?.mode && link?.linkOptions?.mode !== PaymentLinkOptionMode.ONE_OFF_FIXED

    if (isMultiUse) {
        return (
            <ActionButtons
                linkTitle={i18next.t('PayByLink.viewAllPayments')}
                onLinkClick={() => payByLinkStore.viewAllPayments(link)}
                menu={<LinkActionsMenu paymentLink={link} />}
            />
        )
    }

    switch (link.status) {
        case PayByLinkStatus.paid:
            return (
                <ActionButtons
                    linkTitle={i18next.t('PayByLink.paymentDetails')}
                    onLinkClick={() => payByLinkStore.openOverviewModal(link)}
                    menu={<LinkActionsMenu paymentLink={link} />}
                />
            )
        default:
            return <ActionButtons menu={<LinkActionsMenu paymentLink={link} />} />
    }
}
